const isRecord = (value: unknown): value is Record<string, unknown> => {
  return typeof value === 'object' && value !== null && !Array.isArray(value)
}

export const containsUploadingImage = (value: unknown): boolean => {
  if (Array.isArray(value)) {
    return value.some(containsUploadingImage)
  }

  if (!isRecord(value)) return false

  if (value.type === 'image' && isRecord(value.attrs) && value.attrs.uploading === true) {
    return true
  }

  return Object.values(value).some(containsUploadingImage)
}

export const extractImageUrls = (value: unknown): Set<string> => {
  if (Array.isArray(value)) {
    return value.reduce<Set<string>>((urls, nestedValue) => {
      extractImageUrls(nestedValue).forEach((url) => urls.add(url))
      return urls
    }, new Set<string>())
  }

  if (!isRecord(value)) return new Set<string>()

  const urls = Object.values(value).reduce<Set<string>>((accumulator, nestedValue) => {
    extractImageUrls(nestedValue).forEach((url) => accumulator.add(url))
    return accumulator
  }, new Set<string>())

  if (value.type === 'image' && isRecord(value.attrs) && typeof value.attrs.src === 'string') {
    urls.add(value.attrs.src)
  }

  return urls
}
